var React = require('react');

function DownArrowSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 6.411e-08V10M5 10L9 6.11111M5 10L1 6.11111","stroke":"#454545"}));
}

DownArrowSmall.defaultProps = {"width":"10","height":"11","viewBox":"0 0 10 11","fill":"none"};

module.exports = DownArrowSmall;

DownArrowSmall.default = DownArrowSmall;
